import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import posthog from "posthog-js";
import "./index.css";
import App from "./App";

// Benign browser notice, not a real exception: ResizeObserver fires it when a
// resize callback itself causes another layout pass in the same frame (charts
// inside width-animating drawers do this). Only the webpack dev overlay
// escalates it to a blocking "Uncaught runtime error". Capture-phase listener
// runs before the overlay's, so we can swallow exactly this message and
// nothing else.
const RESIZE_OBSERVER_NOISE = [
  "ResizeObserver loop completed with undelivered notifications.",
  "ResizeObserver loop limit exceeded",
];
window.addEventListener(
  "error",
  (e) => {
    if (e.message && RESIZE_OBSERVER_NOISE.some((m) => e.message.includes(m))) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true
);

posthog.init(process.env.REACT_APP_POSTHOG_KEY || "YOUR_POSTHOG_API_KEY", {
  api_host: process.env.REACT_APP_POSTHOG_HOST || "https://us.i.posthog.com",
  capture_pageview: false,
  capture_pageleave: true,
  autocapture: true,
});

const rootElement = document.getElementById("root");
const app = (
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  const root = ReactDOM.createRoot(rootElement);
  root.render(app);
}
